import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import PageFooter from '@/layouts/footer/PageFooter';
import { mapState } from 'vuex';
export default {
  name: 'CommonLayout',
  components: {
    PageFooter: PageFooter
  },
  computed: _objectSpread({}, mapState('setting', ['footerLinks', 'copyright']))
};